import createInstancePlugin from '@elliemae/ds-shared/createDataInstance/createInstancePlugin';
import { groupBy } from 'lodash';

var groupedByData = function groupedByData(groupedBy, composedRows) {
  var grouped = groupBy(composedRows, groupedBy);
  return Object.keys(grouped).map(function (c, key) {
    return {
      id: "grouped-by-".concat(groupedBy, "-").concat(key),
      key: groupedBy,
      value: c,
      children: grouped[c],
      _isGroup: true,
      isGroup: true
    };
  });
};

var GroupingByPlugin = createInstancePlugin('groupedByRows', {
  decorateGrid: function decorateGrid(grid) {
    var _grid$getInstance = grid.getInstance(),
        composedRows = _grid$getInstance.composedRows,
        groupedBy = _grid$getInstance.props.groupedBy;

    grid.composedRows = groupedBy ? groupedByData(groupedBy, composedRows) : composedRows;
    return grid;
  }
});

export { GroupingByPlugin };
//# sourceMappingURL=GroupingByPlugin.js.map
